/* GET SOURCE_SETTINGS NOTES*/
export const GET_SOURCE_SETTINGS_NOTES = "GET_SOURCE_SETTINGS_NOTES"
export const GET_SOURCE_SETTINGS_NOTES_SUCCESS = "GET_SOURCE_SETTINGS_NOTES_SUCCESS"
export const GET_SOURCE_SETTINGS_NOTES_ERROR = "GET_SOURCE_SETTINGS_NOTES_ERROR"

/*CREATE SOURCE_SETTINGS NOTES*/
export const CREATE_SOURCE_SETTINGS_NOTES = "CREATE_SOURCE_SETTINGS_NOTES"
export const CREATE_SOURCE_SETTINGS_NOTES_SUCCESS = "CREATE_SOURCE_SETTINGS_NOTES_SUCCESS"
export const CREATE_SOURCE_SETTINGS_NOTES_ERROR = "CREATE_SOURCE_SETTINGS_NOTES_ERROR"

/*UPDATE SOURCE_SETTINGS NOTES*/
export const UPDATE_SOURCE_SETTINGS_NOTES = "UPDATE_SOURCE_SETTINGS_NOTES"
export const UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS = "UPDATE_SOURCE_SETTINGS_NOTES_SUCCESS"
export const UPDATE_SOURCE_SETTINGS_NOTES_ERROR = "UPDATE_SOURCE_SETTINGS_NOTES_ERROR"

/*DELETE SOURCE_SETTINGS */
export const DELETE_SOURCE_SETTINGS_NOTES = "DELETE_SOURCE_SETTINGS_NOTES"
export const DELETE_SOURCE_SETTINGS_NOTES_SUCCESS = "DELETE_SOURCE_SETTINGS_NOTES_SUCCESS"
export const DELETE_SOURCE_SETTINGS_NOTES_ERROR = "DELETE_SOURCE_SETTINGS_NOTES_ERROR"

/*BULK CREATE SOURCE_SETTINGS NOTES*/
export const BULK_CREATE_SOURCE_SETTINGS_NOTES = "BULK_CREATE_SOURCE_SETTINGS_NOTES"
export const BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS = "BULK_CREATE_SOURCE_SETTINGS_NOTES_SUCCESS"
export const BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR = "BULK_CREATE_SOURCE_SETTINGS_NOTES_ERROR"